module.exports = __webpack_public_path__ + "static/media/light-theme-alerts-count.c6ae2b6f.svg";